// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6bU_F","right":"styles_right__2ivs6"};